import { patchApiRequest } from 'api';

import { ResponseCourse } from '.';

export const blockCourse = (courseId: number, isBlockEdit: boolean): Promise<ResponseCourse> => {
    return patchApiRequest(`/course/block/${courseId}/`, { isBlockEdit });
};
